import { SdkMethodPayloadInterface } from "@modules/sdk/methods/SdkMethodPayloadInterface";

import { WISHLISTS_SDK_METHODS } from "../constants";

class OpenWishlistsDrawerSdkMethodPayload implements SdkMethodPayloadInterface {
    public readonly methodName: WISHLISTS_SDK_METHODS.OPEN_WISHLISTS_DRAWER;
    public onSuccess: () => void;

    constructor(onSuccess: () => void) {
        this.methodName = WISHLISTS_SDK_METHODS.OPEN_WISHLISTS_DRAWER;
        this.onSuccess = onSuccess;
    }
}

export default OpenWishlistsDrawerSdkMethodPayload;
